import { Lead } from './Lead.js'

export const arbor: Lead = {
  companyContext:
    'Arbor is a UK-based EdTech company that provides a modern Management Information System used by thousands of schools and academy trusts. Its proposition is to simplify and integrate school operations—covering student data, attendance, communication, finance, HR, and reporting—so staff spend less time on administration and more time supporting students. By offering an intuitive, data-driven platform with growing AI-powered features, Arbor positions itself as the smarter, more efficient alternative to fragmented legacy systems.',
  files: [{ description: 'job description', url: 'https://files.catbox.moe/mpclf8.pdf' }],
  leadContext:
    'The company Arbor is looking for an interim VP of Engineering. This is needed because the CTO, Damien Brooks, will need to focus on raising funds. I am a candidate for this role.',
  name: 'arbor',
  notes: [
    'one of the two interviewers will be Damien Brooks, the CTO and hiring manager',
    'Damien Brooks is calm an collected',
    'Damien Brooks is looking for sussinct answers',
    'one of the two interviewers will be Laura Kidd, the HRBP of Damien Brooks',
    'Damien Brooks is more focussed on culture, Laura Brooks is more focussed on delivery',
    'the interview will partly be cultrally focussed',
    'the candidate is expected to hit the ground running',
    'the candidate should contain a high eq with focus on execution',
    'the candidate should be able to navigate a complex company and a big team',
    "for arbor, the headcount of engineering grew, but the processes and quality didn't grow yet with headcount, and is a bit stuck in the 'small scale engineering team'",
    'there is a lack of confidence in the leaders reporting into this role in the leadership',
    'some might be upset with this change, how can we get them onboard?',
    'the candidate is expected to also diversify the product',
    'the candidate is expected to be able to work in a high change environment',
    'the candidate is expected to quickly understand the the complexity of the environment',
    'the candidate is expected to have experience in scaling tech, able to work with a product that should have a high availability',
    'the candidate is expected to have a very good commercial accumen (why do we do this, what does this do for the end user, relentless focus on the end user',
    'the candidate is expected to have a very good working relationship with the product craft',
    'the candidate is expected to have great stakeholder management',
    'the candidate is expected to look after three pillars: 1/3: tech: nothing really needed, tech is great & there are great tech people',
    'the candidate is expected to look after three pillars: 2/3: performance of the org: a lot of work is needed here, how do we improve the maturity of the org, how do we improve the performance of the org',
    'the candidate is expected to look after three pillars: 3/3: outcomes: this should lead to improved outcomes',
    'dayrate: for this role the standard dayrate in london is 1200-1400 pound sterling',
    "dayrate: i've proposed 1100 pound sterling dayrate",
    "dayrate: eventually i need to work via an umbrella company, so i've increased my dayrate with 25% to 1375",
    'dayrate: my expectation is that travel is covered by the company',
  ],
  questionAnswers: [
    {
      answer: [
        {
          explanation:
            'Education is one of the most meaningful sectors to contribute to — helping schools spend less time on admin and more time on students has a real societal impact.',
          summary: 'Mission-driven',
        },
        {
          explanation:
            "Arbor is at an exciting stage where the tech is strong, but the organisation needs to mature with its growth. That's exactly where my experience at Booking, Getir, and SnappCar fits in.",
          summary: 'Scaling challenge',
        },
        {
          explanation:
            'I enjoy stepping into high-change environments, quickly bringing clarity, building trust, and raising performance.',
          summary: 'Interim focus',
        },
        {
          explanation:
            'The role requires strong collaboration with product to deliver outcomes, which is where I thrive.',
          summary: 'Partnership with product',
        },
      ],
      question: 'why are you interested in this role?',
    },
  ],
  // prettier-ignore
  todos: [
    { type: 'uncategorized',  description: '[general] todo: generate a clear story how i work together with product' },
    { type: 'uncategorized',  description: 'todo: generate a story how to approach damien being away from the team' },
    { type: 'uncategorized',  description: '[general] todo: generate an answer to how i can be inspirational and aspirational' },
    { type: 'uncategorized',  description: 'todo: generate experience in upscaling or downscaling these Teams - identifying talent, dealing with poor performance, making difficult decisions for the greater good of the team.' },
    { type: 'uncategorized',  description: 'todo: generate potential focus on financial metrics given the investment context.' },
    { type: 'uncategorized',  description: '[already_done?] todo: generate experience in implementing the metrics project at booking' },
    { type: 'uncategorized',  description: '[general] todo: prepare a story of scaling engineering from 80 to 800 within getir, and what my role was with the different headcounts' },
    { type: 'uncategorized',  description: '[general] todo: generate an answer to the question why i want to do contract/interim/fractional vs employment work' },
    { type: 'uncategorized',  description: '[general] todo: generate an answer to the question how you prioritize tech debt against feature development' },
    { type: 'uncategorized',  description: '[general] todo: practice star answers' },
    { type: 'uncategorized',  description: '[general] todo: practice mock interviews' },
    { type: 'uncategorized',  description: '[general] todo: get knowledgebase into verve' },
    { type: 'uncategorized',  description: '[general] todo: internalise arbor feedback: not sussinct / detailed enough' },
  ],
  url: 'https://arbor-education.com/',
}
